import"./Tabs.css.ts.vanilla.css";var s={tablist:"Tabs_tablist__1ns2kbx0"};export{s as styles};
//# sourceMappingURL=Tabs.css.vanilla.js.map
